import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setSettings } from "../../store/slice/ProductListingSettings";
import ProductListingAPICall from "../../service/ProductListingAPICall";
import { loadData } from "../../store/slice/ProductListingAPICall";
import { useSearchParams } from "react-router-dom";
import Modal3D from '../../component/Product/3DModal';
import QuantityPicker from "../../component/Global/Cart/QuantityPicker";
import AddToCart from "../../component/Global/Cart/AddToCart";
import RefreshStockButton from "./RefreshStockButton";
import store from "../../storeWire";
import { system_notification } from "../../store/slice/system";
import ProductCompareSelection from "../../component/Product/ProductCompareSelection";
import { loadData as loadData_filterBoxActiveSelection } from "../../store/slice/ProductListingFilterBoxSelection";
import DisplayQtyMinQtyMult from "../../component/Product/DisplayQtyMinQtyMult";
import DisplayLifeCycleRisk from "../../component/Product/DisplayLifeCycleRisk";
import noImage from '../../assets/images/noimage.png'
import { Tooltip } from "../../component/Tooltip";
import PriceTable from "../../component/Global/Cart/PriceTable";
import AddToBom from "../../component/Global/BOM/AddToBom";
import BackToBomLink from 'src/component/Global/BOM/BackToBomLink';
import Helper from "../../support/Helper";
import exportProductListingData, { functionDataOrder } from "./exportProductListingData";
import no_auth_exportProductListingData from "./no_auth_exportProductListingData";
import ProductInventoryRepository from "../../repository/ProductInventoryRepository";
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import AxiosIndicatorRunTimeLoader from 'src/component/AxiosIndicatorRunTimeLoader';
import { isArray, isNumber, isObject, isEqual } from "underscore";
import liveAuth from 'src/helper/liveAuth';
import { NonLoginSignInButton, Pagination } from 'src/reusable/global';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import CommonCart from "src/component/Global/Cart/Common";
import { useCartStore } from "../../hooks/cart";
import useReduxState from "../../hooks/useReduxState";
import { useProductStore } from "../../hooks/product";
import { useProductPricingStore } from "../../hooks/productPricing";
import { updateSmartly } from "../../store/slice/ProductListingFilterBoxActiveSelection";
import System from 'src/helper/system';
import RoleAndPermission from 'src/helper/RoleAndPermission';
import ShowMoreLess from 'src/component/Product/ShowMoreLess';
import $ from "jquery";
import Export from "../../helper/export";
import ProductLegends from './ProductLegends';
import { applyFilterByMainKeyAndSlug } from 'src/store/slice/ProductListingFilterApplied';
import DesignHubModalPopUp from '../DesignHubModalPopUp';
import NoResultContent from '../HomePageContent/NoResultContent';
import stickyTableHeader from 'src/helper/stickyTableHeader';
import ProductPricingRepository from 'src/repository/ProductPricingRepository';
import { useProductInventoryStore } from 'src/hooks/productInventory';
import CartRepository from 'src/repository/CartRepository';
import Constants from 'src/support/Constants';
import SystemAlerts from 'src/component/SystemAlerts';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import ReusableDiv from 'src/support/ReusableDiv';
import { useAlertStore } from 'src/hooks/Alert';
import NavigateToPDP from 'src/component/Global/Product/NavigateToPDP';
import ProductInventoryDisplay from "../../component/Global/Product/ProductInventoryDisplay";
import { NotifyMe } from "../../component/Global/Product/NotifyMe";

const Listing = (props) => {
    const { isBomPLP, addToBOMSwapModeByBomDetailID } = props
    const [searchParams] = useSearchParams();
    const [__check] = useAxiosIndicatorCheck();
    const [_check_p] = useCheckAuthPermissions();
    const dispatch = useDispatch()
    const [firstServerCall, setFirstServerCall] = useState(true);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);
    const [, setListingAPICallLoader] = useReduxState(false, 'product_listing_listingAPICallLoader'); // Might be no use of this state.
    const compact_view = useSelector((state) => state.entities.ProductListingSettings.compact_view)
    const compact_expander = useSelector((state) => state.entities.ProductListingSettings.compact_expander)
    const filterBoxSelection = useSelector((state) => state.entities.ProductListingFilterBoxSelection)
    const [{ CART_BEFORE_TO_SEND_SERVER }, { get_updated_qty }] = useCartStore();
    const [{ list, category_filter_applied_status, append_facade_options_status, designHubData }, { get_all_design_data, get_product_category_external_search, check_designs_exist }, { }, { optionsAvailable }] = useProductStore();
    const bomId = System.getParams().bomId
    const bomDetailId = System.getParams().bomDetailId
    const [pageLoader, setPageLoader] = useState(false);
    const [designData, setDesignData] = useState();
    const [showDesignHubModal, setShowDesignHubModal] = useState(false);
    const [clickDesignHubId, setClickDesignHubId] = useState(false);
    const [noMessage, setNoMessage] = useState(false);
    const compareProductList = useSelector((state) => state.entities.model_ProductCompare.data, isEqual);
    const [{ pricingList }, { fetch_product_pricing_list }, { }] = useProductPricingStore();
    const [, { fetch_product_inventory_list, get_inventory_by_id },] = useProductInventoryStore();
    const filterApplied = useSelector((state) => state.entities.ProductListingFilterApplied);
    const [{ latest_system_notification_data }, { }, { }] = useDOMAttachToSystemStore();
    const [firstServerCallFilter,] = useReduxState(true, 'setFirstServerCallFilter');
    let c = System.getParams();
    const avUserInfo = liveAuth.getAvUserInfo()
    const [, { get_stock_alerts_products }] = useAlertStore();
    const [, setStockAlertState] = useReduxState({}, "setStockAlertState");
    const userType=System.avUserInfoData.userType
    const {  siteUser:{CORE} } = Constants

    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, [list])

    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: searchParams.get("page") ? parseInt(searchParams.get("page")) : 1,
        limit: searchParams.get("limit") ? parseInt(searchParams.get("limit")) : 20,
        orderby: searchParams.get("orderby") ? searchParams.get("orderby") : '',
        orderbyDirection: searchParams.get("orderbydirection") ? searchParams.get("orderbydirection") : 'asc'
    });

    const fetchDesignData = async (designIds) => {
        if (designIds.length > 0) {
            const params = {
                itemNumberArray: designIds,
                speedBoat: System.avUserInfoData.speedBoatAbbr,
            };
            const results = await get_all_design_data(params);
            if (results && Object.keys(results?.payload).length > 0) {
                setDesignData(results?.payload?.data);
            }
        }
    };

    useEffect(() => {
        if (__check(['PRODUCT_LISTING_API_CALL']).status &&
            __check(['CART_API_CALL']).status === false) {
            setPageLoader(true)

        } else {
            setPageLoader(false)
        }
    }, [__check(['PRODUCT_LISTING_API_CALL']).status])

    useEffect(() => {
        setTimeout(() => {
            if (__check(['PRODUCT_LISTING_API_CALL']).status === false &&
                __check(['UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL']).status === false &&
                __check(['CART_API_CALL']).status === false &&
                __check(['ALL_COUNT_API_CALL']).status === false) {
                setNoMessage(false);
            }
            if (pageLoader === false) {
                setNoMessage(true);
            }
        }, 1500)
    }, [pageLoader])

    const getDisplayStatusOfAddToCart = (single_product_pricing_list, single_product, single_product_inventory) => {
        return new CommonCart().getDisplayStatusOfAddToCart(single_product_pricing_list, single_product, single_product_inventory);
    };

    const getDisplayStatusOfAddToQuote = (single_product_pricing_list, single_product, single_product_inventory) => {
        return new CommonCart().getDisplayStatusOfAddToQuote(false, single_product_inventory, single_product, single_product_pricing_list);
    };

    useEffect(() => {
        async function fetchHere() {
            const urlPathnameMatch = window.location.pathname;

            const manufactureMatch = "/manufacturers/m/c/";
            const checkManufactureMatch = urlPathnameMatch.indexOf(manufactureMatch);

            const categoryMatch = "/products/c/";
            const categoryMatchSearch = "/products/c/search/";
            const checkCategoryMatch = urlPathnameMatch.indexOf(categoryMatch);
            const checkCategoryMatchSearch = urlPathnameMatch.indexOf(categoryMatchSearch);

            if (checkManufactureMatch !== -1) {
                let tempCreateNewUrl = urlPathnameMatch.split("/manufacturers/");

                if (tempCreateNewUrl[1] != undefined) {
                    const resultUrl = await get_product_category_external_search({ requestUrl: '/manufacturers/' + tempCreateNewUrl[1] });
                    if (resultUrl?.payload != undefined) {
                        let tempCategoryName = resultUrl.payload?.categoryName;
                        let tempCategoryLevel = resultUrl.payload?.categoryLevel;
                        let tempManufacturer = resultUrl.payload?.manufacturer;
                        if (tempCategoryName != null && tempCategoryLevel != null) {
                            dispatch(applyFilterByMainKeyAndSlug({ "key": 'ManufacturerName', "main_label": 'Manufacturer', "value": tempManufacturer }));
                            // new ProductRepository().fetchManufacturersBySearchParam(tempManufacturer)
                            dispatch(applyFilterByMainKeyAndSlug({ "key": "Categories", "main_label": "Category", "value": tempCategoryName, "hidden_payload": { "Level": tempCategoryLevel } }));
                            // new ProductRepository().fetchCategoriesBySearchParam(tempCategoryName)
                        }
                    }
                }
            }
            else if (checkCategoryMatch !== -1 && checkCategoryMatchSearch == -1) {
                let tempCreateNewUrl = urlPathnameMatch.split("/products/");
                if (tempCreateNewUrl[1] != undefined) {
                    const resultUrl = await get_product_category_external_search({ requestUrl: '/products/' + tempCreateNewUrl[1] });
                    if (resultUrl?.payload != undefined) {
                        let tempCategoryName = resultUrl.payload?.categoryName;
                        let tempCategoryLevel = resultUrl.payload?.categoryLevel;
                        if (tempCategoryName != null && tempCategoryLevel != null) {
                            dispatch(applyFilterByMainKeyAndSlug({ "key": "Categories", "main_label": "Category", "value": tempCategoryName, "hidden_payload": { "Level": tempCategoryLevel } }));
                        }
                    }
                }
            }
            await fetchFromServer()
            setTimeout(() => {
                $(".floating-table").floatingScroll("init");
            }, 2000)
        }

        fetchHere()
    }, [])

    useEffect(() => {
        async function fetchHere() {
            await fetchFromServer()
        }
        if (firstServerCall === false) {
            fetchHere()
        }

    }, [listObj.page, listObj.limit, listObj.orderby, listObj.orderbyDirection])

    function preferredOrder(obj, order) {
        var newObject = {};
        for (var i = 0; i < order.length; i++) {
            if (obj.hasOwnProperty(order[i])) {
                newObject[order[i]] = obj[order[i]];
            } else {
                newObject[order[i]] = ""
            }
        }

        const filtered = Object.keys(obj)
            .filter(key => key.includes('Tier'))
            .reduce((ob, key) => {
                ob[key] = obj[key];
                return ob;
            }, {});

        newObject = { ...newObject, ...filtered };
        return newObject;
    }

    const fetchFromServer = async (overWritePage = false) => {

        let p = {
            orderby: listObj.orderby,
            orderbydirection: listObj.orderbyDirection
        };

        let page_here = listObj.page;
        let limit_here = listObj.limit;
        if (overWritePage !== false) {
            page_here = overWritePage;
            localStorage.setItem('product_listing_page', page_here);
            setListObj({ ...listObj, page: page_here - 1 })
        }

        if (localStorage.getItem('product_listing_limit')) {
            limit_here = localStorage.getItem('product_listing_limit');
        }
        let res = await new ProductListingAPICall().getProductsForProductListingPageList(parseInt(page_here), parseInt(limit_here), p);
        await dispatch(await loadData({
            data: res
        }));
        setListingAPICallLoader(true) // do not set this before list dispatch
        if (res['@odata.count'] !== undefined) {
            setListObj({ ...listObj, pageCount: Math.ceil(res['@odata.count'] / listObj.limit) });

        }
    };

    const pricing = pricingList;
    const [loadfetchInventoryFromServer, set_loadfetchInventoryFromServer] = useState(true);

    const refreshStock = () => {
        fetchInventoryFromServer()
    }

    useEffect(() => {
        let isDisplayFixedHeader = false;
        let refreshStockButton;
        let callback;
        if (list?.value?.length > 0 && !pageLoader) {
            const sort = toggleOrderBy;
            const tableElement = document?.getElementById("my-table");
            // headerHeght contains height where we need to display static header
            // local
            // const headerHeight =  document?.getElementsByTagName("header") ? document?.getElementsByTagName("header")[0]?.clientHeight :65;
            //sbx
            let headerHeight = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight + 1 : 156;
            const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0].clientHeight : 0;

            if (adminToolBarHeight > 0) {
                headerHeight = headerHeight + adminToolBarHeight;
            }
            // is used to track only one header will display at a moment
            // extra function attach 
            document.addEventListener("scroll", (ScrollEvent) => {
                // current table position from top
                const tablePosition = tableElement ? tableElement.getBoundingClientRect().y : false;
                const paginationPosition = document?.querySelectorAll("div.pagination-row") ? document?.querySelectorAll("div.pagination-row")[0].getBoundingClientRect().y : false;
                if (tablePosition && headerHeight > tablePosition && isNaN(paginationPosition) === false && (Number(headerHeight) + 40 <= Number(paginationPosition)) && !isDisplayFixedHeader) {
                    //function used to display header clone after actual header height is less than headerHeight from top
                    // function(id, headerHeight,  tableContainerId, firstColumnsFixed, sort)
                    if (!document.getElementById("table_copy")) {

                        callback = stickyTableHeader("my-table", headerHeight, "sticky-table-wrapper", 1, sort)
                        // for refresh stock 
                        refreshStockButton = document.getElementsByClassName("refresh-link")
                        //fixed header display now on ui
                        isDisplayFixedHeader = true;
                        refreshStockButton[1].addEventListener("click", refreshStock);
                    }
                } else {
                    if ((headerHeight < tablePosition || (Number(paginationPosition) <= Number(headerHeight) + 40)) && isDisplayFixedHeader && callback) {
                        // switch variable to false for track that clone header hide
                        isDisplayFixedHeader = false;
                        // check element exist before remove event listeners
                        if (refreshStockButton && refreshStockButton[1] && refreshStock) {
                            refreshStockButton[1]?.removeEventListener("click", refreshStock);
                        }
                        // function used to remove the clone header
                        if (Object.prototype.toString.call(callback) == '[object Function]') {
                            callback();
                        }
                    }
                }
            })
        }
        return () => {
            if (callback) {
                // switch variable to false for track that clone header hide
                isDisplayFixedHeader = false;
                // check element exist before remove event listeners
                if (refreshStockButton && refreshStockButton[1] && refreshStock) {
                    refreshStockButton[1]?.removeEventListener("click", refreshStock);
                }
                // function used to remove the clone header
                callback();
                window.scrollTo(0, 0)
            }
        }
    }, [list, pageLoader]);

    useEffect(() => {
        async function fetchHere() {
            await Promise.all([
                fetchInventoryFromServer(),
                fetchPricingFromServer(),
                fetch_stock_alert_products_details()
            ]).then((res) => {
            }).catch(() => { });
            checkDesignsFromServer();
            setTimeout(() => {
                $(".floating-table").floatingScroll("init");
            }, 2000)
        }

        fetchHere()
    }, [list])

    useEffect(() => {
        if (!pageLoader && firstServerCall === false && !monitorFunctionCall) {
            Helper.monitorJSDx()
            setMonitorFunctionCall(true)
            if (typeof avnetAnalytics === 'object') {
                console.log("avnetAnalytics init called")
                avnetAnalytics.init();
            }
        }
    }, [list, pageLoader])

    const checkIfDesignsAvailable = (itemNumber) => {
        if (designHubData && designHubData?.availableDesigns && designHubData?.availableDesigns.find(v => v.itemNumber === itemNumber && v.isDesignsAvailable)) {
            return true
        } else {
            return false
        }
    };

    const getDesignIds = (itemNumber) => {
        const res = designHubData?.availableDesigns.find(v => {
            if (v.itemNumber === itemNumber && v.isDesignsAvailable) {
                return v?.designIds
            }
        })
        return res?.designIds
    }

    const checkDesignsFromServer = async () => {
        if (list?.value && list.value.length > 0) {
            let itemNumbers = [];
            list.value.map((v) => {
                itemNumbers.push(v.ItemNumber)
            });

            await check_designs_exist({ itemNumber: itemNumbers });
        }
    };

    const fetchInventoryFromServer = async () => {
        set_loadfetchInventoryFromServer(true);
        if (list?.value && list.value.length > 0) {
            setFirstServerCall(false)
            let params = [];
            list.value.map((v) => {
                !v?.ERPPartNumberModified && params.push({
                    sboat: v.Sboat,
                    ERPManufacturerCode: v.ERPManufacturerCode,
                    ERPPartNumber: v.ERPPartNumber,
                })
            });

            params.length > 0 && await fetch_product_inventory_list(params)
            set_loadfetchInventoryFromServer(false);
        }
    };

    const [loadfetchPricingFromServer, set_loadfetchPricingFromServer] = useState();

    const fetchPricingFromServer = async () => {
        set_loadfetchPricingFromServer(true)

        if (list?.value && list.value.length > 0) {
            let params = [];
            list.value.map((v) => {
                let _isManual = true;
                if (Helper.valueIsNotNull(c.search))
                    _isManual = CommonCart.isCpnIsManual(v, c.search);

                params.push({
                    partNumber: v?.ERPPartNumberModified ? '' : v.ERPPartNumber,
                    erpManufacturerCode: v.ERPManufacturerCode,
                    erpMfrPartNumber: v.ERPMFRPartNumber,
                    WebCode: v.WebCode,
                    ObsoleteFlag: v.ObsoleteFlag,
                    customerPartNumber: !_isManual ? Helper.toUpperCase(c.search) : undefined // 14790
                })

            });
            if (isGuestFullRights()) {
                let paramSet = await new ProductPricingRepository().getPricingParams(params);
                await fetch_product_pricing_list(paramSet)
                set_loadfetchPricingFromServer(false)
            }

        }
    };
    const fetch_stock_alert_products_details = async () => {
        if(userType !== CORE)
            return;
        if (list?.value && list.value.length > 0) {
            let params = [];
            list.value.map((v) => {
                params.push({
                    itemNumber: v?.ItemNumber,
                    erpPartNumber: v?.ERPPartNumber,
                    erpMfrPartNumber: v?.ERPMFRPartNumber,
                    customerPartNumber: v?.CustomerPartNumbers.length > 0
                        ? v.CustomerPartNumbers[0]?.CPN : ""
                })

            });

            let res = await get_stock_alerts_products(params);

            if (res?.data) {
                const stockAlertList = res?.data?.stockAlertPartDetails.reduce((acc, item) => {
                    acc[item.itemNumber] = item;
                    return acc;
                }, {});
                setStockAlertState(stockAlertList)
            } else {
                setStockAlertState({})
            }
        }
    };
    const smartlyLoadListingAPICallLoader = (v, idx) => {
        // Prevent loader for universal search
        if (__check(['PRODUCT_LISTING_API_CALL',]).status &&
            __check(['UNIVERSAL_SEARCH_DEDICATED_API_BULK_CALL']).status === false &&
            __check(['CART_API_CALL']).status === false) {
            return true;
        }
        return loadfetchPricingFromServer;
    }
    const getPricing = (ERPMFRPartNumber, ERPPartNumber, ERPPartNumberModified) => {
        ERPPartNumber = ERPPartNumberModified ? '' : ERPPartNumber;
        if (pricing[ERPMFRPartNumber + '-' + ERPPartNumber]) {
            return pricing[ERPMFRPartNumber + '-' + ERPPartNumber];
        }
        return [];
    };
    const getInventory = (ERPPartNumber) => {
        return get_inventory_by_id(ERPPartNumber)
    };

    const getInventoryText = (ERPPartNumber) => {
        let inventoryLabel = '0';
        let inventory = getInventory(ERPPartNumber);
        if (inventory && inventory.qas) {
            inventoryLabel = inventory.qas;
        }
        return inventoryLabel;
    }

    const getStickyclass = () => {
        let stickyClass = 'floating-table product-table  product-table-striped sticky-table-wrapper products-table-wrapper table-responsive position-relative';

        if (compareProductList && Object.keys(compareProductList).length > 0) {
            stickyClass += ' sticky-scrollbar-compare'
        }
        return stickyClass
    }

    const getLeadTimeText = (ERPPartNumber) => {
        let leadTimeLabel = 'Not Available';
        let inventory = getInventory(ERPPartNumber);
        if (inventory &&
            inventory.plifz) {
            leadTimeLabel = inventory.plifz;
        }
        return leadTimeLabel;
    }

    const getOrderByClass = (columnName) => {
        if (columnName === listObj.orderby) {
            return 'sorting sorting_' + listObj.orderbyDirection
        }
        return 'sorting'
    };
    const toggleOrderBy = async (columnName) => {
        setListObj({
            ...listObj,
            orderby: columnName,
            orderbyDirection: (listObj.orderbyDirection === "desc" ? "asc" : "desc")
        });
    };

    const authLoggedIn = (keyIndex) => {
        return liveAuth.check();
    };

    const handlePageClick = async (data) => {
        let here_page = 0
        here_page = data.selected + 1;
        setListObj({ ...listObj, page: here_page })
        localStorage.setItem('product_listing_page', here_page)
        Helper.scrollTop();
    };
    const setPageLimit = async (event) => {
        setListObj({ ...listObj, limit: event.target.value });
    };
    const renderTooltip = (props) => (
        <>
            <RefreshStockButton />
            <br />
            Refresh the product availability to a real time call
        </>
    );

    const getPriceText = (price, isPrice = false) => {
        if (price && price.demandQuantityOut && price.demandQuantityOut > -1 && price.marketPrice &&
            price.marketPrice > -1) {
            return Helper.getFormatNumber(Number(price.marketPrice), window.mct, window.mcs, 5, false);
        }
        return '';
    }

    const exportData = async () => {
        const data = list.value
        let final_Export_Data = [];
        let key_list_to_export;
        if (liveAuth.check()) {
            key_list_to_export = new exportProductListingData()
        } else {
            key_list_to_export = new no_auth_exportProductListingData()
        }

        await data.map(async (single_product) => {
            let single_final_product = {};

            Object.entries(key_list_to_export).map((s) => {
                let key_list_to_export_field_list = s[0];
                if (single_product[key_list_to_export_field_list] !== undefined) {
                    single_final_product[key_list_to_export_field_list] = (key_list_to_export_field_list.toLowerCase() === 'min' || key_list_to_export_field_list.toLowerCase() === 'mult') && isNumber(single_product[key_list_to_export_field_list]) ? single_product[key_list_to_export_field_list] : single_product[key_list_to_export_field_list];
                }
            });

            let erpPartNumber = data.filter(x => x.ERPMFRPartNumber == single_final_product.PartNumber).length > 0 ?
                data.filter(x => x.ERPMFRPartNumber == single_final_product.PartNumber)[0]['ERPPartNumber'] : '';
            if (erpPartNumber != '') {
                let price = getPricing(single_product.ERPMFRPartNumber, erpPartNumber, single_product.ERPPartNumberModified);
                let quantity = await new ProductInventoryRepository().getQuantityFromCartBeforeSendToServerByERPPartNumber(single_product.ItemNumber);
                if (!quantity) {
                    quantity = single_final_product.QtyMin;
                }

                single_final_product['Stock (Availability)'] = getInventoryText(erpPartNumber);
                single_final_product['Lead Time'] = getLeadTimeText(erpPartNumber);

                if (liveAuth.check()) {
                    single_final_product['Quantity'] = quantity;
                    if (single_product['ShortDescription']) {
                        single_final_product['Description'] = single_product['ShortDescription']
                    }

                    single_final_product['Currency'] = window.mct;

                    const isCustomerPrice = Helper.checkIsCustomerPrice(price);

                    Helper.rangToArray(1, price.length).map((v) => {
                        single_final_product['Tier ' + v + ' - Quantity'] = 'Tier ' + v + ' - Quantity'
                        single_final_product['Tier ' + v + ' - Price'] = 'Tier ' + v + ' - Price'

                        single_final_product['Tier ' + v + ' - Quantity'] = '';
                        single_final_product['Tier ' + v + ' - Price'] = '';

                        if (!isCustomerPrice && price[v - 1] !== undefined && price[v - 1].demandQuantityOut !== undefined && price[v - 1].demandQuantityOut > 0) {
                            single_final_product['Tier ' + v + ' - Quantity'] = `${price[v - 1].demandQuantityOut}+`;
                        }
                        if (price[v - 1] && price[v - 1].marketPrice > 0) {
                            single_final_product['Tier ' + v + ' - Price'] = getPriceText(price[v - 1]);
                        }
                    });
                }
            }
            const customerPartNumber = new CartRepository().getCustomerPartNumberFromERPPArtNumber(single_product.ItemNumber)
            single_final_product['Customer Part Number'] = customerPartNumber;
            const reordered_single_final_product = preferredOrder(single_final_product, new functionDataOrder())
            final_Export_Data.push(reordered_single_final_product);
        });
        let f = [];
        await Promise.all(Object.entries(final_Export_Data).map((v, key) => {
            if (Object.entries(v[1]).length > 0) {
                Object.keys(v[1]).map((key, i) => {
                    if (v[1][key] === '' || v[1][key] === 0 || v[1][key] === null || (isObject(v[1][key]) && Object.entries(v[1][key]).length <= 0) || (isArray(v[1][key]) && v[1][key].length <= 0) || v[1][key] === undefined) {
                        v[1][key] = ''
                    }
                })
            }
            f.push(v[1]);
        }));
        await exportDataToFile(f);
        showDownloadMessage();
    };

    const exportDataToFile = async (data) => {
        Export.toExcel(data, 'ProductListingExport')
    };
    const detectDynamicFieldIsAttribute = (field) => {
        return new ProductListingAPICall().getFieldType(field) === 'attributes';
    };


    useEffect(() => {
        async function fetchHere() {
            if (listObj.page === 1) {
                await fetchFromServer()
            } else {
                setListObj({ ...listObj, page: 1 })
            }
        }

        if (firstServerCall === false && firstServerCallFilter === false) {
            fetchHere()
        }
    }, [filterApplied])

    const [compact_view_individual, set_compact_view_individual] = useState([]);

    const toggle_compact_view_individual = async (singleProduct) => {
        if (!compact_view_individual.includes(singleProduct.ItemNumber)) {
            set_compact_view_individual((prevValue) => [...prevValue, singleProduct.ItemNumber]);
        } else {
            const arrayWithoutRemovedItem = compact_view_individual.filter((x) => x != singleProduct.ItemNumber)
            set_compact_view_individual(arrayWithoutRemovedItem)
        }
    };

    const displayPricingBasedOnSingleProduct = (v) => {
        if (!new CommonCart().getDisplayStatusOfPricingTable(getInventory(v.ERPPartNumber), v)) {
            return false;
        }
        let p;
        if (CART_BEFORE_TO_SEND_SERVER[v.ItemNumber] === undefined) {
            p = Number(parseFloat(new CommonCart().getCurrentPriceByQuantityAndPriceArray(getPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified), v.QtyMult).marketPrice * v.QtyMin).toFixed(3));
        } else {
            p = Number(parseFloat(new CommonCart().getCurrentPriceByQuantityAndPriceArray(getPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified), CART_BEFORE_TO_SEND_SERVER[v.ItemNumber].quantityAddToCart).marketPrice * CART_BEFORE_TO_SEND_SERVER[v.ItemNumber].quantityAddToCart).toFixed(3));
        }

        if ((isNumber(p) && !isNaN(p)) === false) {
            return false;
        }
        return (
            <>
                {(isNumber(p) && !isNaN(p)) ? Helper.getFormatNumber(p, window.mct, window.mcs, 2, true, false) : ''}
            </>
        );
    };

    useEffect(() => {
        async function fetchHere() {
            let o = optionsAvailable();
            if (category_filter_applied_status === true && o) {
                Object.entries(o).filter((v, i) => {
                    dispatch(updateSmartly({
                        selection: v[1],
                        status: true,
                    }));
                });
                dispatch(loadData_filterBoxActiveSelection({ data: store.getState().entities.ProductListingFilterBoxActiveSelection }));
            }
        }

        fetchHere()
    }, [category_filter_applied_status]);

    useEffect(() => {
        async function fetchHere() {
            let o = optionsAvailable();
            if (append_facade_options_status === 'yes' && o) {
                Object.entries(o).filter((v, i) => {
                    dispatch(updateSmartly({
                        selection: v[1],
                        status: true,
                    }));
                });
                dispatch(loadData_filterBoxActiveSelection({ data: store.getState().entities.ProductListingFilterBoxActiveSelection }));
            }
        }

        fetchHere()
    }, [append_facade_options_status]);

    const openContactUsPopup = () => {
        store.dispatch(system_notification({
            name: 'ContactUsPopup',
            data: { restrict: true },
        }));
    };
    const openAddToBOM = (e) => {
        if (_check_p('PD_ADD_TO_BOM').status === false) {
            openContactUsPopup();
            return false;
        }

        if (isBomPLP === 'yes') {
            store.dispatch(system_notification({
                name: 'AddedToBomPopup',
                data: {
                    single_product: e,
                    swap_mode: addToBOMSwapModeByBomDetailID,
                    bomId,
                    bomDetailId
                },
            }));
        } else {

            const _product = get_updated_qty(e, CART_BEFORE_TO_SEND_SERVER)
            store.dispatch(system_notification({
                name: 'AddToBOMPopup',
                data: {
                    single_product: _product,
                    addFrom: 'PLP'
                }
            }));
        }
    };

    const isGuestFullRights = () => {
        return (_check_p('PDG_ADD_TO_CART').status &&
            _check_p('PDG_ADD_TO_BOM').status &&
            _check_p('PDG_CLICK_TO_QUOTE').status);
    }

    const isAuthAccountLess = () => {
        return _check_p('PD_ADD_TO_BOM').status === true
    }

    const getGuestDisplayTooltipButton = (v) => {
        return (isGuestFullRights() === true || isAuthAccountLess()) ?
            (
                <div className="add-to-bom" onClick={(e) => openAddToBOM(v)}>
                    <a className="img-text">
                        <img className="img h-auto" alt="BOM" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAYAAAACsSQRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAAARBJREFUeNqc0z9ugzAUBvBv6JwxE1KGdwAOUSQWdsaOHqGHeHvOgCp1YwvqHm7AAZozZLb0ZXl2HP6kVYZPNsL+2eBnkETZVijbCvss2wEYABw3MgFowviyrUASSBEABwBDOiiNLcAU2kT2WbbbQDpDIvQKMiQIATSvIDmAwtoGwLBAwpa3/skKeEdsB41lSvprKQwp5sgkInTOUUQIgKpKEYkBEFsDDnOEqkrvPVWVzjmeTj9UVXZf3+z7niJC732AmjXkqqpx4nkcGXZ2Hkf+Xi6xfYY8rB4mqyrruqaqxjxDutk3P/RnuRqQL47YXhRWULk9LxJqaHE68wv4zzpZRz4/3t/+uMVpBgAdSdwGABOMQylvJGBSAAAAAElFTkSuQmCC" />
                        <span className="blue text">
                            Add To BOM
                        </span>
                    </a>
                </div>
            ) : (
                <Tooltip
                    position={'bottom center'}
                    opener={() => (
                        <div className="add-to-bom btn-unauthorize">
                            <a className="img-text">
                                <img className="img h-auto" alt="BOM" src="data:image/png;base64,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" />
                                <span className="blue text">
                                    Add To BOM
                                </span>
                            </a>
                        </div>
                    )}
                    content={() => (
                        <>
                            <div dangerouslySetInnerHTML={{ __html: RoleAndPermission.getGuestErrorForBOMCart() }}>
                            </div>
                        </>
                    )} />
            );
    }
    const openGuestPopUp = (title, body) => {
        System.popup('GuestPopupActionButton', { title: title, body: body })
    };
    const detectCompactByItemNumber = (ItemNumber) => {
        if (Object.entries(compact_view_individual).length > 0 && compact_view_individual[ItemNumber] !== undefined) {
            return compact_view_individual[ItemNumber];
        }
        return false;
    };

    const getPriceLines = (itemNumber) => {
        return detectCompactByItemNumber(itemNumber) ? 100 : 2;
    }

    const checkProductTitleMatch = (product) => {
        if (product && product.VendorPartNumber && product.ERPMFRPartNumber) {
            return product.ERPMFRPartNumber == product.VendorPartNumber;
        }
        return false;
    };

    const showDownloadMessage = () => {
        System.alert(Constants.downloadMsg, 'success', 'exportMsg')
    }

    useEffect(() => {
        if (document.getElementsByClassName('snippet') && document.getElementsByClassName('snippet').length > 0) {
            document.getElementsByClassName('snippet')[0].style.display = 'none';
        }
    }, [])

    const showFarnellInventory = (ERPPartNumber) => {
        System.popup('FarnellInventoryStockPopup', {
            ERPPartNumber: ERPPartNumber
        })
    }


    return (
        <>
            {latest_system_notification_data.errorModule !== undefined &&
                latest_system_notification_data.errorModule === 'exportMsg' &&
                <div className='mt-2'>
                    <SystemAlerts />
                </div>
            }
            <div className="container-fluid maxw100 container-fluid-plp   compare-open">
                <>
                    <div className="table-area">
                        <>
                            <div className="table-area-actions d-flex flex-wrap">
                                <div className="table-area-actions-left">
                                    <BackToBomLink isBomPLP={isBomPLP} />
                                </div>
                                <div className="table-area-actions-right ms-auto">
                                    <div className="table-area-actions-buttons">
                                        <Tooltip
                                            opener={() => (
                                                <button className="bs5 btn btn-secondary" style={{ cursor: 'auto' }}>
                                                    <i className="fa fa-info-circle text-darkgreen me-2" aria-hidden="true" />
                                                    TOOLTIP
                                                </button>
                                            )}
                                            content={() => (
                                                renderTooltip()
                                            )}
                                        />
                                        <button
                                            style={{
                                                cursor: 'pointer'
                                            }} onClick={exportData}
                                            className="bs5 btn btn-secondary">Download
                                        </button>
                                    </div>
                                    <div className="density-links">
                                        <div className="view-tools">
                                            View:
                                        </div>
                                        <div className="btn-group switchbtns">
                                            <Tooltip
                                                position={'top right'}
                                                opener={() => (
                                                    <button aria-label="Expand table rows to see more information per line" type="button"
                                                            onClick={() => {
                                                                dispatch(setSettings({
                                                                    key: 'compact_view',
                                                                    value: false,
                                                                }));

                                                                set_compact_view_individual([])
                                                            }}
                                                            className={compact_view ? 'btn btn-primary btn-normal' : 'btn btn-primary btn-normal active'}>
                                                        <i className="density-expanded-icon btn-normal" />
                                                    </button>
                                                )}
                                                content={() => (
                                                    <>
                                                        Expand Table Rows, <br />To see more information per line.
                                                    </>
                                                )}
                                            />
                                            <Tooltip
                                                position={'top right'}
                                                opener={() => (
                                                    <button aria-label="Condense table rows to see more results at once" type="button"
                                                            onClick={() => {
                                                                dispatch(setSettings({
                                                                    key: 'compact_view',
                                                                    value: true,
                                                                }));
                                                            }}
                                                            className={compact_view ? 'btn btn-primary btn-dense active' : 'btn btn-primary btn-dense'}>
                                                        <i className="density-condensed-icon" />
                                                    </button>
                                                )}
                                                content={() => (
                                                    <>
                                                        Condense Table Rows, <br />To see more results at once.
                                                    </>
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {pageLoader === false && firstServerCall && noMessage && list?.value?.length === 0 && !c?.search ?
                                <>
                                    <br />
                                    <NoResultContent
                                        message={
                                            'No Results Found'
                                        }
                                    />
                                </>
                                :
                                (pageLoader || (list !== undefined &&
                                    list.value !== undefined &&
                                    list.value.length > 0) || (firstServerCall && !pageLoader)) &&
                                <div className='position-relative'>
                                    <div>
                                        {(pageLoader || (firstServerCall && !pageLoader)) && <AxiosIndicatorRunTimeLoader overlay={true} />}
                                    </div>
                                    <div
                                        id="sticky-table-wrapper" className={getStickyclass()}>

                                        <table className="bs5 table sticky-table table-bordered search-products-table" id="my-table">
                                            <thead>
                                            <tr>
                                                <th>Product
                                                    <span aria-label="ERPMFRPartNumber"
                                                          className={'sort-container ' +
                                                              getOrderByClass('ERPMFRPartNumber')
                                                          }
                                                          onClick={async () => {
                                                              await toggleOrderBy('ERPMFRPartNumber')
                                                          }}
                                                    >
                                                        </span>
                                                </th>
                                                <th>Price</th>
                                                <th className='w300'>
                                                    Availability
                                                    <span aria-label="Stock"
                                                          className={'sort-container ' +
                                                              getOrderByClass('Stock')
                                                          }
                                                          onClick={async () => {
                                                              await toggleOrderBy('Stock')
                                                          }}
                                                    ></span>
                                                    <RefreshStockButton fetchInventoryFromServer={async () => {
                                                        // setClickRefreshStock(true);
                                                        fetchInventoryFromServer();
                                                    }} />
                                                </th>
                                                <th>Manufacturer
                                                    <span
                                                        aria-label='ManufacturerName'
                                                        className={'sort-container ' +
                                                            getOrderByClass('ManufacturerName')
                                                        }
                                                        onClick={async () => {
                                                            await toggleOrderBy('ManufacturerName')
                                                        }}></span>
                                                </th>
                                                <th aria-label='information'>Information</th>
                                                {filterBoxSelection && Object.entries(filterBoxSelection).length > 0 &&
                                                    Object.entries(filterBoxSelection).map((v) => (
                                                        <React.Fragment key={Helper.UUID()}>
                                                            {detectDynamicFieldIsAttribute(v[1].slug) === true &&
                                                                <th>{v[1].main_label}</th>
                                                            }
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                            </thead>
                                            <tbody className="border-top-0">
                                            {list?.value && list.value.length &&
                                                list.value.map((v, i) => (
                                                    <React.Fragment key={i}>
                                                        {showDesignHubModal && clickDesignHubId === v.ItemNumber && (
                                                            <DesignHubModalPopUp
                                                                showDesignHubModal={showDesignHubModal}
                                                                setShowDesignHubModal={setShowDesignHubModal}
                                                                productDetail={v}
                                                                designData={designData}
                                                            />
                                                        )}
                                                        <tr className={compact_view ? (compact_view_individual.length > 0 && compact_view_individual.includes(v.ItemNumber) ? 'dense-row' : 'dense dense-row') : ''}>
                                                            <td className=" product-th additional-stock-wrapper mobile-block product-data">

                                                                <div className="col-12 nopadding product-td">
                                                                    <div className="bs5 row m-0 flex-nowrap">
                                                                        <div className="col-auto p-0 position-relative">
                                                                            <div className={compact_view ? (compact_view_individual.length > 0 && compact_view_individual.includes(v.ItemNumber) ? 'product-expander d-block expanded' : 'product-expander d-block') : 'product-expander'}
                                                                                 onClick={() => {
                                                                                     dispatch(setSettings({
                                                                                         key: 'compact_expander',
                                                                                         value: !compact_expander,
                                                                                     }));
                                                                                     toggle_compact_view_individual(v)
                                                                                 }}
                                                                            >
                                                                                <a href={void (0)} className="text-green">
                                                                                    {compact_view && ((compact_view_individual).length == 0 || (compact_view_individual.length > 0 && !compact_view_individual.includes(v.ItemNumber))) ?
                                                                                        <i className="fa fa-angle-double-down" /> : <i className="fa fa-angle-double-up" />
                                                                                    }
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4 product-info nopadding">
                                                                            <div className="product-img sect-1 text-center">
                                                                                <NavigateToPDP
                                                                                    rel="nofollow"
                                                                                    data={{
                                                                                        ManufacturerName: v?.ManufacturerName,
                                                                                        ERPMFRPartNumber: v?.ERPMFRPartNumber,
                                                                                        ItemNumber: v?.ItemNumber,
                                                                                    }}
                                                                                >
                                                                                    <img className="img"
                                                                                         src={v.AssetURL ? v.AssetURL : noImage}
                                                                                         alt="LM339PT" />
                                                                                </NavigateToPDP>
                                                                            </div>
                                                                            <div className="sect-2">
                                                                                <div className="sect-row">
                                                                                    {authLoggedIn(i) === false ?
                                                                                        <div className="add-to-bom">
                                                                                            <a onClick={() => openGuestPopUp('BOM Upload', 'Sign-in to upload BOM.')}
                                                                                               className="img-text">
                                                                                                <img className="img h-auto" alt="BOM" src="data:image/png;base64,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" />
                                                                                                <span className="blue text">
                                                                                                        Add To BOM
                                                                                                    </span>
                                                                                            </a>
                                                                                        </div>
                                                                                        :
                                                                                        getGuestDisplayTooltipButton(v)
                                                                                    }

                                                                                    <div className="datasheet">
                                                                                        {Helper.valueIsNotNull(v?.Datasheet) ? (
                                                                                            <a className="datasheet-align img-text" aria-label="Datasheet"
                                                                                               rel="nofollow"
                                                                                               href={v?.Datasheet}
                                                                                               onClick={() => showDownloadMessage()}
                                                                                               target="_new">
                                                                                                <div className="datasheet_img datasheet_img_download img" />
                                                                                                <span className="blue text">
                                                                                                        Datasheet
                                                                                                    </span>
                                                                                            </a>
                                                                                        ) : (
                                                                                            ReusableDiv.dataSheetTooltip()
                                                                                        )}
                                                                                    </div>


                                                                                    <DisplayLifeCycleRisk single_product={v} />
                                                                                </div>

                                                                                <div className="shipping_address_checkbox">
                                                                                    <ProductCompareSelection single_product={v}
                                                                                                             model_ProductCompare_data={compareProductList} />
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                        <div className="col-7 static-position product-info-sect-2">
                                                                            <div>
                                                                                <div>
                                                                                    <div className="product-name text-blue">
                                                                                        <NavigateToPDP data={{
                                                                                            ManufacturerName: v?.ManufacturerName,
                                                                                            ERPMFRPartNumber: v?.ERPMFRPartNumber,
                                                                                            ItemNumber: v?.ItemNumber,
                                                                                        }}>
                                                                                            <strong>{v.ERPMFRPartNumber ? v.ERPMFRPartNumber : ''}</strong>
                                                                                        </NavigateToPDP>
                                                                                    </div>
                                                                                    {v.ManufacturerName &&
                                                                                        <a href={`/${System.avUserInfoData?.speedBoatNameLower}/manufacturers/m/${v.ManufacturerName?.toLowerCase().replace(/\+/g, "and").replace(/\&/g, "and").replace(/\./g, "").replace(/\//g, "-").replace(/\,/g, "").replace(/\s/g, '-').replace(/\---/g, '-')}`}
                                                                                           className="text-blue cursor-pointer"
                                                                                        >
                                                                                            {v.ManufacturerName}
                                                                                        </a>
                                                                                    }
                                                                                </div>

                                                                                {v.ShortDescription ?
                                                                                    <ShowMoreLess single_product={v} /> : ''}
                                                                            </div>

                                                                            <div className="bottom-align dense-hide">

                                                                                <Modal3D value={v} />

                                                                                {v.ERPMFRPartNumber &&
                                                                                    <div className='mt-2'><strong>Manufacturer Part
                                                                                        #: </strong>
                                                                                        {v.ERPMFRPartNumber}
                                                                                    </div>
                                                                                }

                                                                                <div className={checkProductTitleMatch(v) ? 'mt-2 d-none' : 'mt-2'}><strong>Also known as: </strong>
                                                                                    {v.VendorPartNumber ? v.VendorPartNumber : ''}
                                                                                </div>

                                                                                {checkIfDesignsAvailable(v?.ItemNumber) && (
                                                                                    <>
                                                                                        <div onClick={() => {
                                                                                            fetchDesignData(
                                                                                                getDesignIds(v?.ItemNumber)
                                                                                            );
                                                                                            setShowDesignHubModal(true)
                                                                                            setClickDesignHubId(v?.ItemNumber)

                                                                                            if (window?.digitalData) {
                                                                                                window.digitalData.event.eventinfo.events = "Design Button Click from PDP,PLP";
                                                                                            }
                                                                                        }} className="designhub d-flex align-items-center mt-2">
                                                                                            <div className="designshub_img"></div>
                                                                                            <span className="bs5 text-blue lh-base cursor-pointer">
                                                                                                    Designs
                                                                                                </span>
                                                                                        </div>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            {avUserInfo && isGuestFullRights() === true &&
                                                                <td className="price-th">
                                                                    {smartlyLoadListingAPICallLoader(v) === true ?
                                                                        <AxiosIndicatorRunTimeLoader /> :
                                                                        <div className="price-td bs5 row m-0 flex-nowrap">
                                                                            <div className="col ps-0 price-table">
                                                                                <PriceTable
                                                                                    auto_select_from_cart_data={false}
                                                                                    linesToDisplay={!compact_view && !compact_view_individual.includes(v.ItemNumber) ? 100 : compact_view_individual.includes(v.ItemNumber) ? 100 : getPriceLines(v.ItemNumber)}
                                                                                    compact_view={compact_view && compact_view_individual.includes(v.ItemNumber)}
                                                                                    single_product_inventory={getInventory(v.ERPPartNumber)}
                                                                                    single_product={v}
                                                                                    single_product_pricing_list={getPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified)} />
                                                                            </div>
                                                                            <div className="col-auto p-0 quanitity-add2cart-wrapper">
                                                                                {displayPricingBasedOnSingleProduct(v) !== false &&
                                                                                    <div className="price dense-hide mb-2">
                                                                                        {window.mct === window.mcs &&
                                                                                            <strong>
                                                                                                {window.mct} :
                                                                                            </strong>
                                                                                        }
                                                                                        {window.mct !== window.mcs &&
                                                                                            <strong>
                                                                                                {window.mct} <span>{window.mcs}</span>:
                                                                                            </strong>
                                                                                        }
                                                                                        <div
                                                                                            className="pull-right font-bold">
                                                                                            <>
                                                                                                {displayPricingBasedOnSingleProduct(v)}
                                                                                            </>
                                                                                        </div>
                                                                                    </div>
                                                                                }
                                                                                <div
                                                                                    className="text-start small-text light light-text collapse_minmax">
                                                                                    <DisplayQtyMinQtyMult
                                                                                        single_product={v} />
                                                                                </div>
                                                                                <div
                                                                                    className={compact_view_individual.includes(v.ItemNumber) ? "d-flex condensed-qty-view" : `d-flex ${!getDisplayStatusOfAddToCart(getPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified), v, getInventory(v.ERPPartNumber)) && 'flex-column'}`}>
                                                                                    <div className="quantity clearfix ">
                                                                                        <div className="quantity-picker">
                                                                                            <div
                                                                                                className="bs5 input-group flex-nowrap border-0">
                                                                                                <QuantityPicker single_product={v}
                                                                                                                single_product_pricing_list={getPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified)}
                                                                                                                single_product_inventory={getInventory(v.ERPPartNumber)}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    {compact_view && !compact_view_individual.includes(v.ItemNumber) &&
                                                                                        <AddToCart
                                                                                            disable_loader_rendering={true}
                                                                                            initialDispatchOnFirstLoad={getInventory(v.ERPPartNumber).qas > 0 ? true : false}
                                                                                            special_class_for_add_to_quote={'bs5 btn btn-secondary'}
                                                                                            isBomPLP={isBomPLP}
                                                                                            isCompactView={!compact_view_individual.includes(v.ItemNumber) ? true : false}
                                                                                            addToBOMSwapModeByBomDetailID={addToBOMSwapModeByBomDetailID}
                                                                                            single_product_pricing_list={getPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified)}
                                                                                            single_product_inventory={getInventory(v.ERPPartNumber)}
                                                                                            single_product={v}
                                                                                            isOnSamePage={true}
                                                                                            isFrom="PLP"
                                                                                        />
                                                                                    }
                                                                                </div>
                                                                                {compact_view && (getDisplayStatusOfAddToCart(getPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified), v, getInventory(v.ERPPartNumber)) || getDisplayStatusOfAddToQuote(getPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified), v, getInventory(v.ERPPartNumber))) && !compact_view_individual.includes(v.ItemNumber) &&
                                                                                    <div className='condensed-view-add-to-cart'>
                                                                                        <AddToCart
                                                                                            initialDispatchOnFirstLoad={getInventory(v.ERPPartNumber).qas > 0 ? true : false}
                                                                                            special_class_for_add_to_quote={'bs5 btn btn-secondary'}
                                                                                            isBomPLP={isBomPLP}
                                                                                            isCompactViewHide={compact_view && !compact_view_individual.includes(v.ItemNumber) ? true : false}
                                                                                            disable_loader_rendering={true}
                                                                                            addToBOMSwapModeByBomDetailID={addToBOMSwapModeByBomDetailID}
                                                                                            single_product_pricing_list={getPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified)}
                                                                                            single_product_inventory={getInventory(v.ERPPartNumber)}
                                                                                            single_product={v}
                                                                                            isOnSamePage={true}
                                                                                            isFrom="PLP"
                                                                                        />
                                                                                    </div>
                                                                                }

                                                                                {!compact_view &&
                                                                                    <div className='condensed-view-add-to-cart'>
                                                                                        <AddToCart
                                                                                            initialDispatchOnFirstLoad={getInventory(v.ERPPartNumber).qas > 0 ? true : false}
                                                                                            special_class_for_add_to_quote={'bs5 btn btn-secondary'}
                                                                                            isBomPLP={isBomPLP}
                                                                                            isCompactViewHide={false}
                                                                                            disable_loader_rendering={true}
                                                                                            addToBOMSwapModeByBomDetailID={addToBOMSwapModeByBomDetailID}
                                                                                            single_product_pricing_list={getPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified)}
                                                                                            single_product_inventory={getInventory(v.ERPPartNumber)}
                                                                                            single_product={v}
                                                                                            isOnSamePage={true}
                                                                                            isFrom="PLP"
                                                                                        />
                                                                                    </div>
                                                                                }

                                                                                <AddToBom
                                                                                    isBomPLP={isBomPLP}
                                                                                    addToBOMSwapModeByBomDetailID={addToBOMSwapModeByBomDetailID}
                                                                                    single_product={v}
                                                                                />

                                                                                {compact_view && compact_view_individual.includes(v.ItemNumber) &&
                                                                                    <AddToCart
                                                                                        initialDispatchOnFirstLoad={getInventory(v.ERPPartNumber).qas > 0 ? true : false}
                                                                                        special_class_for_add_to_quote={'bs5 btn btn-secondary'}
                                                                                        isBomPLP={isBomPLP}
                                                                                        disable_loader_rendering={true}
                                                                                        addToBOMSwapModeByBomDetailID={addToBOMSwapModeByBomDetailID}
                                                                                        single_product_pricing_list={getPricing(v.ERPMFRPartNumber, v.ERPPartNumber, v.ERPPartNumberModified)}
                                                                                        single_product_inventory={getInventory(v.ERPPartNumber)}
                                                                                        single_product={v}
                                                                                        isOnSamePage={true}
                                                                                        isFrom="PLP"
                                                                                    />
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </td>
                                                            }

                                                            {((!authLoggedIn(i) || (authLoggedIn(i) && isGuestFullRights() === false))) &&
                                                                <td className='align-middle'>
                                                                    <NonLoginSignInButton
                                                                        isAuthAccLess={authLoggedIn(i) && isGuestFullRights() === false} />
                                                                </td>
                                                            }

                                                            <td>
                                                                <div className='d-flex flex-column'>
                                                                    <ProductInventoryDisplay single_product={v} isFrom={Constants.isFrom.PLP} single_product_inventory={get_inventory_by_id(v?.ERPPartNumber)} />
                                                                    {get_inventory_by_id(v?.ERPPartNumber).qas < 1 && authLoggedIn() && userType === CORE &&<NotifyMe single_product={v} fetch_stock_alert_products_details={fetch_stock_alert_products_details} />}
                                                                </div>
                                                            </td>
                                                            <td>{v.ManufacturerName ? v.ManufacturerName : ''}</td>
                                                            <td>
                                                                <ul className={compact_view ? "list-text plp-info-ledgend d-flex flex-wrap" : "list-text plp-info-ledgend"}>
                                                                    <ProductLegends
                                                                        single_product={v}
                                                                        onlyIcon={!!compact_view}
                                                                        onlyIconTitle={!compact_view} />
                                                                </ul>
                                                            </td>
                                                            {filterBoxSelection && Object.entries(filterBoxSelection).length > 0 &&
                                                                Object.entries(filterBoxSelection).map((v_listing) => (
                                                                    <React.Fragment key={Helper.UUID()}>
                                                                        {detectDynamicFieldIsAttribute(v_listing[1].slug) === true &&
                                                                            <td>
                                                                                {v.dynamic_columns !== undefined &&
                                                                                    v.dynamic_columns[v_listing[1].slug] !== undefined &&
                                                                                    <>
                                                                                        {v.dynamic_columns[v_listing[1].slug]}
                                                                                    </>
                                                                                }
                                                                            </td>
                                                                        }
                                                                    </React.Fragment>
                                                                ))
                                                            }
                                                        </tr>
                                                    </React.Fragment>
                                                ))
                                            }
                                            </tbody>
                                        </table>
                                    </div>


                                    <div className="pagination-row">
                                        <div className="pagination-wrapper">
                                            <Pagination pageCount={listObj.pageCount} setPageLimit={setPageLimit} handlePageClick={handlePageClick} page={listObj.page - 1} limit={listObj.limit} />
                                        </div>
                                    </div>
                                </div>

                            }
                        </>
                    </div>
                </>
                {pageLoader === false && !firstServerCall && noMessage && list?.value?.length === 0 && Helper.valueIsNotNull(c.search) &&
                    <>
                        <br />
                        <NoResultContent
                            message={
                                'No Results Found for <b>"' + c.search + '"</b>'
                            }
                        />
                    </>
                }
            </div>


        </>
    );
};

export default Listing;